import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  role: 'Artesana Principiante',
  text: 'Llevaba meses intentando hacer una billetera decente. Con estos patrones, mi primer intento quedó perfecto. Las instrucciones son clarísimas.',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  rating: 5
}, {
  name: 'Carlos R.',
  role: 'Dueño de Taller',
  text: 'Comprar patrones individuales me estaba costando una fortuna. Esta biblioteca tiene todo lo que necesito para mi negocio. Los bolsos tote son los más vendidos.',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  rating: 5
}, {
  name: 'Ana L.',
  role: 'Hobbyista',
  text: 'Los ebooks de bonificación valen el precio por sí solos. Aprendí a bruñir los bordes correctamente y ahora mis trabajos parecen de tienda de lujo.',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
  rating: 4
}, {
  name: 'Javier M.',
  role: 'Marroquinero',
  text: 'Excelente calidad en los archivos PDF. Imprimes, cortas y listo. Me ha ahorrado horas de diseño y pruebas fallidas.',
  avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
  rating: 5
}, {
  name: 'Elena S.',
  role: 'Emprendedora',
  text: 'Inicié mi pequeña marca gracias a estos diseños. Son modernos, limpios y muy fáciles de seguir. ¡Totalmente recomendado!',
  avatar: 'https://randomuser.me/api/portraits/women/90.jpg',
  rating: 4
}, {
  name: 'Roberto V.',
  role: 'Artesano',
  text: 'La organización en Drive es perfecta. Accedo desde mi tablet en el taller y tengo todo a la mano. Una inversión increíble.',
  avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
  rating: 5
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 15
    }
  }
};
export function Testimonials() {
  return <section className="bg-cream py-24 px-4 sm:px-6 lg:px-8" data-id="element-185">
      <div className="max-w-7xl mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="text-center mb-16" data-id="element-187">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-leather-dark mb-6" data-id="element-188">
            Lo Que Dicen Nuestros Artesanos
          </h2>
          <div className="w-24 h-1.5 bg-gold mx-auto rounded-full" data-id="element-189"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-190">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} whileHover={{
          scale: 1.03
        }} className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 transition-shadow hover:shadow-xl" data-id="element-191">
              <div className="flex items-center gap-4 mb-6" data-id="element-192">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-gold/30" data-id="element-193" />
                <div data-id="element-194">
                  <h4 className="font-bold text-leather-dark text-lg" data-id="element-195">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500 font-medium" data-id="element-196">
                    {testimonial.role}
                  </p>
                </div>
              </div>
              <div className="flex text-gold mb-4" data-id="element-197">
                {[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < testimonial.rating ? 'fill-current' : 'text-gray-300'}`} data-id="element-198" />)}
              </div>
              <p className="text-gray-700 leading-relaxed italic text-lg" data-id="element-199">
                "{testimonial.text}"
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}